import AccountRegisterForm from '@components/account/account-register-form/account-register-form';
import { assert, v2_fetchAuthorizedCustomer } from '@crocodille/common';
import { AppPage } from '@framework/page';
import PageMeta from '@framework/page-meta';
import { useRouter } from '@framework/router';
import { getAppLayoutWithCart } from '@layouts/app-layout/app-layout';
import { localized, shippingRoute } from '@routing';
import { getApp } from '@utils/app';
import { getServerSideTranslationProps } from '@utils/i18n';
import { GetServerSideProps } from 'next';
import { getProviders } from 'next-auth/react';
import { useTranslation } from 'next-i18next';

interface RegisterPageProps {
  readonly providers: string[];
}

const Register: AppPage<RegisterPageProps> = ({
  providers: enabledProviders,
}) => {
  const { query } = useRouter();
  const { t } = useTranslation();

  const error = query.error;

  assert(!error || typeof error === 'string');

  return (
    <>
      <PageMeta pageTitle={t('register_page.title')} description="" />
      <AccountRegisterForm enabledProviders={enabledProviders} error={error} />
    </>
  );
};

Register.getLayout = (page) => {
  return getAppLayoutWithCart(page);
};

export const getServerSideProps: GetServerSideProps<RegisterPageProps> = async (
  ctx,
) => {
  const app = getApp(ctx);

  const customer = await v2_fetchAuthorizedCustomer(app);

  if (customer) {
    return {
      redirect: {
        destination: localized(
          app.locale,
          shippingRoute({ shipping: 'courier' }),
        ),
        permanent: false,
      },
    };
  }

  const [providerMap, translationProps] = await Promise.all([
    getProviders(),
    getServerSideTranslationProps(app, ['messages']),
  ]);

  const providers = Object.keys(providerMap ?? {}).filter(
    (provider) => provider !== 'credentials',
  );

  return {
    props: {
      providers,
      ...translationProps,
    },
  };
};
export default Register;
